"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const FilterComponent_1 = require("../FilterComponent");
exports.DropdownEditor = (props) => {
    const { onUpdate, column, value, row, ref, defaultValue, onBlur, onKeyDown, ...rest } = props;
    const { dataField } = column;
    const [options, setOptions] = react_1.useState([]);
    const [selected, setSelected] = react_1.useState(value);
    react_1.useEffect(() => {
        const { table } = column.formatExtraData;
        const {} = table;
        setOptions([{ value: "value", label: "value" }]);
    }, []);
    const onChangeFilter = (data) => {
        setSelected(data);
        onUpdate(data);
    };
    const handleInputChange = (newValues, actionMeta) => {
        if (actionMeta.action === "input-blur") {
            onUpdate(selected);
        }
    };
    return (react_1.default.createElement(FilterComponent_1.FilterComponent, Object.assign({}, rest, { onChange: onChangeFilter, onInputChange: handleInputChange, options: options })));
};
//# sourceMappingURL=DropDownEditor.js.map